var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[_vm.className]},_vm._l((_vm.subWidgets),function(item){return _c(item.component,{key:item.cuid,tag:"component",attrs:{"cuid":item.cuid}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }